module.exports = __webpack_public_path__ + "img/Z60Q_13.46dfe131.jpg";